// FLAG:docuAiEnhancements — situation building reaches the useDocuAi analysis-state selector.
// Keep the whole additive path unreachable while the chat feature (and therefore its parent) is OFF.
import buildChatSituation, { ChatSituationOptions } from '@/modules/document/utils/chat-situation'

export const buildRagChatSituation = (
  docuAiEnhancementsEnabled: boolean,
  document: unknown,
  view?: string,
  options: ChatSituationOptions = {},
) => docuAiEnhancementsEnabled
  ? buildChatSituation(document, view, options)
  : undefined
